import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'

export default function button(props) {
    return (
        <button type="button" className={`Tombol ${props.btn_tombol}`}>
            <Link to={props.to}>{props.tombol}</Link>  
        </button>
    )
}
